// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"collapse_wrapper_3MQLn","btnAccordion":"collapse_btnAccordion_fH5vD","caretClosed":"collapse_caretClosed_1X79b"};